import { render, staticRenderFns } from "./app.orgs.vue?vue&type=template&id=cf0431d0&lang=pug&"
import script from "./app.orgs.vue?vue&type=script&lang=js&"
export * from "./app.orgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports